// use only recoil
export interface FilterChipsType {
  isVaccine: boolean;
  isIsolate: boolean;
}

export interface FilterVaccinationIsolationType {
  CheckVaccinationEntrance: boolean;
  CheckVaccinationReturn: boolean;
  CheckUnVaccinationEntrance: boolean;
  CheckUnVaccinationReturn: boolean;
}

export interface FilterIsolationType {
  [key: string]: boolean;
  vaccinationEntrance: boolean;
  vaccinationReturn: boolean;
  unVaccinationEntrance: boolean;
  unVaccinationReturn: boolean;
}

export enum FilterIsolationKeys {
  vaccinationEntrance = "vaccinationEntrance",
  vaccinationReturn = "vaccinationReturn",
  unVaccinationEntrance = "unVaccinationEntrance",
  unVaccinationReturn = "unVaccinationReturn",
}

// use recoil and componant
export enum VaccinationType {
  all = "all",
  unvaccinated = "unvaccinated",
  pfizer = "pfizer",
  moderna = "moderna",
  janssen = "janssen",
  az = "az",
}

// use only component
export enum LabelType {
  isVaccine = "isVaccine",
  isIsolate = "isIsolate",
}

export enum FilterChipNames {
  isVaccination = "백신 접종 여부",
  isIsolation = "격리 여부",
  all = "백신 접종 여부",
  unvaccinated = "미접종",
  pfizer = "화이자",
  moderna = "모더나",
  janssen = "얀센",
  az = "아스트라제네카",
  entrance = "입국 시",
  return = "귀국 시",
  entranceReturn = "입국, 귀국 시",
}

export interface FilterInfoType {
  id: number;
  filterName: FilterChipNames;
  icon: string;
  active: boolean;
  label: LabelType;
}

export interface VaccinationItemsType {
  children: string;
  value: VaccinationType;
}
